import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export interface PhoneNumberValidatorError {
  phoneNumber: true;
}

export const PhoneNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const REGEX_PHONE = "^\\+?(?:[0-9] ?){6,14}[0-9]$"; // @@@c
  const regexp = new RegExp(REGEX_PHONE);
  return !control.value || regexp.test(control.value)
    ? null
    : ({ phoneNumber: true } as PhoneNumberValidatorError);
};
